import * as exTable from '../../table';

// ----------------------------------------------------------------------------

function clear(element: HTMLElement, config: Record<string, any> = {}): void {
    exTable.clear(element, config);
}

// ----------------------------------------------------------------------------

export { clear };
